// extracted by mini-css-extract-plugin
export default {"Paragraph":"intro_Paragraph__ftezf"};